registerComponent("sections/home-videos", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * O slick de 2020 (`slidesToShow: 2` / `slidesToScroll: 2`, `1` a partir do
 * `breakpoint: 767`, `infinite: false`) vira um `Asa.trilho`. São DOIS por
 * janela, e não três: o arquivo da Fase 7 descreve os três trilhos da home com
 * a mesma conta — ver a correção no programa. O degrau mora no
 * `_home-videos.less` e o trilho o lê de lá; nenhum `matchMedia` aqui.
 *
 * ⚠️ DUAS caixas de pontos. O legado trocava o `appendDots` por breakpoint —
 * `.slider-dots-desk` (na coluna do título) fora do celular e o `.slider-dots`
 * do `blocks/slider-controls` dentro dele. O `Asa.trilho` aceita as duas e
 * escreve a mesma lista nas duas; quem mostra uma por vez é a folha.
 *
 * ⚠️ ESTE COMPONENTE NÃO RENDERIZA EM NENHUMA URL. O único call site na home
 * (`pages/home/index.blade.php:16`) está COMENTADO desde antes da reescrita, e
 * o outro é `pages/help`, que por sua vez não renderiza
 * (`UnreferencedComponentsTest::test_pages_help_does_not_render`). Como o
 * comentário Blade contém o texto da tag, o `UnreferencedComponentsTest` o
 * enxerga como call site e não acusa nada. Logo, nada aqui é exercitado pelo
 * `browser-check`: o que prova este arquivo é o `yarn lint`, o `node --check`
 * do bundle e o grep de dependência legada. Candidato ao protocolo de remoção
 * da Fase 9, junto de `modals/modal-contact`, `sections/home-insights`,
 * `pages/help` e `pages/wealth-planning`.
 */

const lista = component.querySelector('.slider');

if (lista) {
    Asa.trilho(lista, Object.assign(
        { itens: '[data-component-name="blocks/card-content"]', passo: 'pagina' },
        Asa.controlesDoTrilho(component.querySelector('[data-component-name="blocks/slider-controls"]')),
        {
            pontos: [
                component.querySelector('.slider-dots-desk'),
                component.querySelector('[data-component-name="blocks/slider-controls"] .slider-dots'),
            ].filter(Boolean),
        },
    ));
}

});
